import styles from "./label.module.less";
import PropTypes from "prop-types";

const Label = (props) => {
  return (
    <div className={[styles.labelWrapper, props.extraClass ? props.extraClass : ""].join(" ")}>
      <span className={[styles.label].join(" ")}>{props.title}</span>
    </div>
  );
};

Label.propTypes = {
  extraClass: PropTypes.string,
  title: PropTypes.string,
};

export default Label;
